<template>

	<div class="agenda_side_block" id="agenda_side_block" style="height: 100%">
		<div class="agenda_side text-center pt-5 pl-2 pr-2" id="agenda_side">
			<span class="cursor-pointer disp-block" id="open_agenda_side_decision"> <i class="bi bi-pin-angle-fill"></i>
			</span> <span class="cursor-pointer disp-block mt-2" id="open_agenda_side_important"> <i class="bi bi-exclamation-circle-fill"></i>
			</span> <span class="cursor-pointer disp-block mt-2" id="open_agenda_side_task"> <i class="bi bi-pin-task-fill bi-pin-task-fill2"></i>
			</span> <span class="cursor-pointer disp-block mt-2" id="open_agenda_side_tag"> <i class="bi bi bi-tags-fill2 bi-tags-fill3"></i>
			</span>
		</div>
		<div class="agenda_side_detail" id="agenda_side_detail" style="display: none;">
			<div class="agenda_side_detail_head">
				<ul class="list-group list-group-horizontal agenda_side-header w-100">
					<li class="list-group-item cursor-pointer" title="閉じる" id="close_agenda_side"><i class="bi bi-chevron-right" style="font-size: 1.2rem"></i></li>
					<li class="agenda_side_title">サマリ</li>
				</ul>
			</div>
			<div class="agenda_side_detail_main" id="agenda_side_detail_main">
				<div class="nav nav-tabs text-center" role="tablist">
					<a class="nav-item nav-link topline" id="nav-decision-tab" data-toggle="tab" href="#nav-decision" role="tab" aria-controls="nav-decision" aria-selected="true" style="width: 25%;">決定</a> <a class="nav-item nav-link topline" id="nav-important-tab" data-toggle="tab" href="#nav-important" role="tab" aria-controls="nav-important" aria-selected="false" style="width: 25%;">重要</a> <a class="nav-item nav-link topline" id="nav-task-tab" data-toggle="tab" href="#nav-task" role="tab" aria-controls="nav-task" aria-selected="false" style="width: 25%;">タスク</a> <a class="nav-item nav-link topline" id="nav-tag-tab" data-toggle="tab" href="#nav-tag" role="tab" aria-controls="nav-tag" aria-selected="false" style="width: 25%;">タグ</a>
				</div>
				<div class="nav-contents">
					<div class="tab-content" id="nav-tabContent-right" v-bind:classes="isSelect">
						<div class="tab-pane fade" id="nav-decision" role="tabpanel" aria-labelledby="nav-decision-tab">
							<template v-for="agenda in ListCheckExist(agenda_detail)" :key="agenda.AGENDA_DETAIL_ID">
								<div class="agendablock" v-if="isShowDecision(agenda.AGENDA_DETAIL_ID)">
									<span class="agenda_title_contents text-white">
										<span class="circle-wrapper">
											<span class="number-circle">
												<span class="text-white">{{ agenda.NUM }}</span>
											</span>
											<span class="my-2 ml-2 title_contents">{{ agenda.CONTENTS }}</span>
										</span>
									</span>
									<template v-for="minutes in minutestlisthapyo(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-if="minutes.decision">
											<p class="text-truncate" :target=minutes.id>
												<i class="mr-1 bi bi-pin-angle-fill"></i>
												<span class="disp-title" style="padding-left: 0px !important;">{{minutes.minutes_value}}</span>
											</p>
										</template>
									</template>
									<template v-for="minutes in minutestlistkaiwa(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">	
										<template v-if="minutes.decision">
											<p class="text-truncate" :target=minutes.id>
												<i class="mr-1 bi bi-pin-angle-fill"></i>
												<span class="disp-title" style="padding-left: 0px !important;">{{minutes.minutes_value}}</span>
											</p>
										</template>
									</template>
								</div>
							</template>
						</div>
						<div class="tab-pane fade" id="nav-important" role="tabpanel" aria-labelledby="nav-important-tab">
							<template v-for="agenda in ListCheckExist(agenda_detail)" :key="agenda.AGENDA_DETAIL_ID">
								<div class="agendablock" v-if="isShowImportant(agenda.AGENDA_DETAIL_ID)">
									<span class="agenda_title_contents text-white">
										<span class="circle-wrapper">
											<span class="number-circle">
												<span class="text-white">{{ agenda.NUM }}</span>
											</span>
											<span class="my-2 ml-2 title_contents">{{ agenda.CONTENTS }}</span>
										</span>
									</span>
									<template v-for="minutes in minutestlisthapyo(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-if="minutes.important">
											<p class="text-truncate" :target=minutes.id>
												<i class="mr-1 bi bi-exclamation-circle-fill"></i>
												<span class="disp-title" style="padding-left: 0px !important;">{{minutes.minutes_value}}</span>
											</p>
										</template>
									</template>
									<template v-for="minutes in minutestlistkaiwa(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">	
										<template v-if="minutes.important">
											<p class="text-truncate" :target=minutes.id>
												<i class="mr-1 bi bi-exclamation-circle-fill"></i>
												<span class="disp-title" style="padding-left: 0px !important;">{{minutes.minutes_value}}</span>
											</p>
										</template>
									</template>
								</div>
							</template>
						</div>
						<div class="tab-pane fade" id="nav-task" role="tabpanel" aria-labelledby="nav-task-tab">
							<template v-for="agenda in ListCheckExist(agenda_detail)" :key="agenda.AGENDA_DETAIL_ID">
								<div class="agendablock" v-if="isShowTask(agenda.AGENDA_DETAIL_ID)">
									<span class="agenda_title_contents text-white">
										<span class="circle-wrapper">
											<span class="number-circle">
												<span class="text-white">{{ agenda.NUM }}</span>
											</span>
											<span class="my-2 ml-2 title_contents">{{ agenda.CONTENTS }}</span>
										</span>
									</span>
									<template v-for="minutes in minutestlisthapyo(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-if="minutes.taskid">
											<p class="mr-2 text-truncate minutes-task" :taskorg=minutes.taskorg :taskorgname=minutes.taskorgname :taskperson=minutes.taskperson :taskpersonname=minutes.taskpersonname :taskgroup=minutes.tasukgroup :taskid=minutes.taskid :id=minutes.taskid :target=minutes.id>
												<i class="innericon mr-1 bi bi-pin-task-fill"></i>
												<span>
													<span class="innericon_span"></span>
													<span class="task_date">
														<template v-if="minutes.taskDate">{{ minutes.taskDate }}</template>
													</span>
													<span class="task_date_noval">
														<template v-if="!minutes.taskDate">未設定</template>
													</span>
												</span>
												<span class="disp-title-task" :nameflag=minutes.nameFlag :savaflag=minutes.saveFlag>
													<template v-if="minutes.taskName">{{ minutes.taskName }}</template>
													<template v-else>{{ minutes.minutes_value }}</template>
												</span>
											</p>
										</template>
									</template>
									<template v-for="minutes in minutestlistkaiwa(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-if="minutes.taskid">
											<p class="mr-2 text-truncate minutes-task" :taskorg=minutes.taskorg :taskorgname=minutes.taskorgname :taskperson=minutes.taskperson :taskpersonname=minutes.taskpersonname :taskgroup=minutes.tasukgroup :taskid=minutes.taskid :id=minutes.taskid :target=minutes.id>
												<i class="innericon mr-1 bi bi-pin-task-fill"></i>
												<span>
													<span class="innericon_span"></span>
													<span class="task_date">
														<template v-if="minutes.taskDate">{{ minutes.taskDate }}</template>
													</span>
													<span class="task_date_noval">
														<template v-if="!minutes.taskDate">未設定</template>
													</span>
												</span>
												<span class="disp-title-task" :nameflag=minutes.nameFlag :savaflag=minutes.saveFlag>
													<template v-if="minutes.taskName">{{ minutes.taskName }}</template>
													<template v-else>{{ minutes.minutes_value }}</template>
												</span>
											</p>
										</template>
									</template>
								</div>
							</template>
						</div>	
						<div class="tab-pane fade" id="nav-tag" role="tabpanel" aria-labelledby="nav-tag-tab">
							<template v-for="agenda in ListCheckExist(agenda_detail)" :key="agenda.AGENDA_DETAIL_ID">
								<div class="agendablock" v-if="isShowTag(agenda.AGENDA_DETAIL_ID)">
									<span class="agenda_title_contents text-white">
										<span class="circle-wrapper">
											<span class="number-circle">
												<span class="text-white">{{ agenda.NUM }}</span>
											</span>
											<span class="my-2 ml-2 title_contents">{{ agenda.CONTENTS }}</span>
										</span>
									</span>
									<template v-for="minutes in minutestlisthapyo(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-for="intag in minutes.tag">
											<template v-if="intag && intag.id">
												<p class="mr-2 w-100 text-truncate" minutes-tag="" :tagname=intag.title :tagid=intag.id :id=intag.id :title=intag.title :target=intag.target>
													<i class="innericon mr-1 bi bi-tags-fill2 ">
														<span class="innericon_span_noupdate ml-1">{{ intag.title }}</span>
													</i>
												</p>
											</template>
										</template>
									</template>
									<template v-for="minutes in minutestlistkaiwa(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">
										<template v-for="intag in minutes.tag">
											<template v-if="intag && intag.id">
												<p class="mr-2 w-100 text-truncate" minutes-tag="" :tagname=intag.title :tagid=intag.id :id=intag.id :title=intag.title :target=intag.target>
													<i class="innericon mr-1 bi bi-tags-fill2 ">
														<span class="innericon_span_noupdate ml-1">{{ intag.title }}</span>
													</i>
												</p>
											</template>
										</template>
									</template>
								</div>
							</template>
						</div>

					</div>					
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";

export default {
	props: {
		username: String,
		agenda_detail: Object,
		infoHapyo: Object,
		infoKaiwa: Object,
	},
	data: () => ({
		isSelect: null,
	}),
	
	created() {
		
	},
	methods: {

		ListCheckExist(elem) {
			if (elem) {
				return elem;
			}
		},

		minutestlisthapyo(agendaid) {
			if (this.infoHapyo && this.infoHapyo[agendaid]) {
				this.infoHapyo[agendaid].splice();
				return this.infoHapyo[agendaid];
			}
		},

		minutestlistkaiwa(agendaid) {
			if (this.infoKaiwa && this.infoKaiwa[agendaid]) {
				this.infoKaiwa[agendaid].splice();
				return this.infoKaiwa[agendaid];
			}
		},

		isShowImportant(agenda_detail_id) {
			
			if (this.infoHapyo && this.infoHapyo[agenda_detail_id]) {
				let index = this.infoHapyo[agenda_detail_id].findLastIndex(({important}) => important === true);
				if (index != -1) {
					return true;
				}
			} 

			if (this.infoKaiwa && this.infoKaiwa[agenda_detail_id]) {
				let index = this.infoKaiwa[agenda_detail_id].findLastIndex(({important}) => important === true);
				if (index != -1) {
					return true;
				} 
			} 
			return false;
		},

		isShowDecision(agenda_detail_id) {

			if (this.infoHapyo && this.infoHapyo[agenda_detail_id]) {
				let index = this.infoHapyo[agenda_detail_id].findLastIndex(({decision}) => decision === true);
				if (index != -1) {
					return true;
				}
			} 

			if (this.infoKaiwa && this.infoKaiwa[agenda_detail_id]) {
				let index = this.infoKaiwa[agenda_detail_id].findLastIndex(({decision}) => decision === true);
				if (index != -1) {
					return true;
				} 
			} 
			return false;
		},

		isShowTask(agenda_detail_id) {

			if (this.infoHapyo && this.infoHapyo[agenda_detail_id]) {
				let index = this.infoHapyo[agenda_detail_id].findLastIndex(({taskid}) => taskid != null);
				if (index != -1) {
					return true;
				}
			} 

			if (this.infoKaiwa && this.infoKaiwa[agenda_detail_id]) {
				let index = this.infoKaiwa[agenda_detail_id].findLastIndex(({taskid}) => taskid != null);
				if (index != -1) {
					return true;
				} 
			} 
			return false;
		},

		isShowTag(agenda_detail_id) {

			if (this.infoHapyo && this.infoHapyo[agenda_detail_id]) {
				for (var i=0; i<this.infoHapyo[agenda_detail_id].length; i++) {
					if (this.infoHapyo[agenda_detail_id][i]["tag"] && this.infoHapyo[agenda_detail_id][i]["tag"].length) {
						return true;
					}
				}
			} 

			if (this.infoKaiwa && this.infoKaiwa[agenda_detail_id]) {
				for (var i=0; i<this.infoKaiwa[agenda_detail_id].length; i++) {
					if (this.infoKaiwa[agenda_detail_id][i]["tag"] && this.infoKaiwa[agenda_detail_id][i]["tag"].length) {
						return true;
					}
				}
			} 
			return false;
		},

		createRightDecision() {
			if($("#nav-tabContent-right").attr("classes") != "decision") {
				return false;
			}

			var $main = $("#nav-decision");
			$main.html("");
			var $minute_rows = $(".minute_row").not("[dummy-row]");

			$.each($minute_rows,function(i, elem) {
				var $agendablock = $("<div></div>").addClass("agendablock");
				var $minute_row = $(elem);
				var $taskarealist = $(elem).find(".base_minutes").not("[dummy-row]").find(".decision-area p");
				if($taskarealist.length) {
					var $agenda_row = $minute_row.prev();
					var $naiyou = "";
					if($agenda_row.find(".naiyou").length) {
						$naiyou = $agenda_row.find(".naiyou").val();
					} else {
						$naiyou = $agenda_row.find(".td-contents").text();
					}
					var agendano = $agenda_row.find(".td-num").text();
					const $spanwrapper = $('<span class="circle-wrapper"></span>');
					const $spancircle = $('<span class="number-circle"></span>');
					const $spannum = $('<span class="text-white"></span>').text(agendano);
					$spancircle.append($spannum);
					$spanwrapper.append($spancircle);
					var $h1 = $("<span></span>").addClass("my-2 ml-2 title_contents").text($naiyou);
					const $span = $('<span class="agenda_title_contents text-white"></span>');
					$span.append($spanwrapper).append($h1);
					$agendablock.append($span);
					$agendablock.append($taskarealist.clone(false));
					$main.append($agendablock);
				}
			});
		},
		
		createRightImportant() {
			if($("#nav-tabContent-right").attr("classes") != "important") {
				return false;
			}

			var $main = $("#nav-important");
			$main.html("");
			var $minute_rows = $(".minute_row").not("[dummy-row]");

			$.each($minute_rows,function(i, elem) {
				var $agendablock = $("<div></div>").addClass("agendablock");
				var $minute_row = $(elem);
				var $taskarealist = $(elem).find(".base_minutes").not("[dummy-row]").find(".important-area p");
				if($taskarealist.length) {
					var $agenda_row = $minute_row.prev();
					var $naiyou = "";
					if($agenda_row.find(".naiyou").length) {
						$naiyou = $agenda_row.find(".naiyou").val();
					} else {
						$naiyou = $agenda_row.find(".td-contents").text();
					}
					var agendano = $agenda_row.find(".td-num").text();
					const $spanwrapper = $('<span class="circle-wrapper"></span>');
					const $spancircle = $('<span class="number-circle"></span>');
					const $spannum = $('<span class="text-white"></span>').text(agendano);
					$spancircle.append($spannum);
					$spanwrapper.append($spancircle);
					var $h1 = $("<span></span>").addClass("my-2 ml-2 title_contents").text($naiyou);
					const $span = $('<span class="agenda_title_contents text-white"></span>');
					$span.append($spanwrapper).append($h1);
					$agendablock.append($span);
					$agendablock.append($taskarealist.clone(false));
					$main.append($agendablock);
				}
			});
		},
		
		createRightTask() {
			if($("#nav-tabContent-right").attr("classes") != "task") {
				return false;
			}

			var $main = $("#nav-task");
			$main.html("");
			var $minute_rows = $(".minute_row").not("[dummy-row]");

			$.each($minute_rows,function(i, elem) {
				var $agendablock = $("<div></div>").addClass("agendablock");
				var $minute_row = $(elem);
				var $taskarealist = $(elem).find(".base_minutes").not("[dummy-row]").find(".task-area p");
				if($taskarealist.length) {
					var $agenda_row = $minute_row.prev();
					var $naiyou = "";
					if($agenda_row.find(".naiyou").length) {
						$naiyou = $agenda_row.find(".naiyou").val();
					} else {
						$naiyou = $agenda_row.find(".td-contents").text();
					}
					var agendano = $agenda_row.find(".td-num").text();
					const $spanwrapper = $('<span class="circle-wrapper"></span>');
					const $spancircle = $('<span class="number-circle"></span>');
					const $spannum = $('<span class="text-white"></span>').text(agendano);
					$spancircle.append($spannum);
					$spanwrapper.append($spancircle);
					var $h1 = $("<span></span>").addClass("my-2 ml-2 title_contents").text($naiyou);
					const $span = $('<span class="agenda_title_contents text-white"></span>');
					$span.append($spanwrapper).append($h1);
					$agendablock.append($span);
					$agendablock.append($taskarealist.clone(false));
					$main.append($agendablock);
				}
			});
		},
		
		createRightTag() {
			if($("#nav-tabContent-right").attr("classes") != "tag") {
				return false;
			}

			var $main = $("#nav-tag");
			$main.html("");
			var $minute_rows = $(".minute_row").not("[dummy-row]");

			$.each($minute_rows,function(i, elem) {
				var $agendablock = $("<div></div>").addClass("agendablock");
				var $minute_row = $(elem);
				var $taskarealist = $(elem).find(".base_minutes").not("[dummy-row]").find(".tag-area p");
				if($taskarealist.length) {
					var $agenda_row = $minute_row.prev();
					var $naiyou = "";
					if($agenda_row.find(".naiyou").length) {
						$naiyou = $agenda_row.find(".naiyou").val();
					} else {
						$naiyou = $agenda_row.find(".td-contents").text();
					}
					var agendano = $agenda_row.find(".td-num").text();
					const $spanwrapper = $('<span class="circle-wrapper"></span>');
					const $spancircle = $('<span class="number-circle"></span>');
					const $spannum = $('<span class="text-white"></span>').text(agendano);
					$spancircle.append($spannum);
					$spanwrapper.append($spancircle);
					var $h1 = $("<span></span>").addClass("my-2 ml-2 title_contents").text($naiyou);
					const $span = $('<span class="agenda_title_contents text-white"></span>');
					$span.append($spanwrapper).append($h1);
					$agendablock.append($span);
					$agendablock.append($taskarealist.clone(false));
					$main.append($agendablock);
				}
			});
		},
		
		refreshSideBar() {
			if($("#nav-tabContent-right").attr("classes") == "decision") {
				this.createRightDecision();
			} else if($("#nav-tabContent-right").attr("classes") == "important") {
				this.createRightImportant();
			} else if($("#nav-tabContent-right").attr("classes") == "task") {
				this.createRightTask();
			} else if($("#nav-tabContent-right").attr("classes") == "tag") {
				this.createRightTag();
			}
		},
	},
	mounted() {
		const _self = this;
		
		$(document).on("click", '#open_agenda_side_decision, #nav-decision-tab', function(e) {
			_self.isSelect = "decision";
			$("#agenda_side").hide();
			$("#agenda_side_detail").show(0, function(){
				$("#agenda_side_detail_main a.nav-item").removeClass("active");
				$("#nav-decision-tab").tab('show');
			});
		});

		$(document).on("click", '#open_agenda_side_important, #nav-important-tab', function(e) {
			_self.isSelect = "important";
			$("#agenda_side").hide();
			$("#agenda_side_detail").show(0, function(){
				$("#agenda_side_detail_main a.nav-item").removeClass("active");
				$("#nav-important-tab").tab('show');
			});
		});

		$(document).on("click", '#open_agenda_side_task, #nav-task-tab', function(e) {
			_self.isSelect = "task";
			$("#agenda_side").hide();
			$("#agenda_side_detail").show(0, function(){
				$("#agenda_side_detail_main a.nav-item").removeClass("active");
				$("#nav-task-tab").tab('show');
			});
		});

		$(document).on("click", '#open_agenda_side_tag, #nav-tag-tab', function(e) {
			_self.isSelect = "tag";
			$("#agenda_side").hide();
			$("#agenda_side_detail").show(0, function(){
				$("#agenda_side_detail_main a.nav-item").removeClass("active");
				$("#nav-tag-tab").tab('show');
			});
		});

		$(document).on("click", '#close_agenda_side', function(e) {
			$("#agenda_side_detail").hide(0, function(){
			});
			$("#agenda_side").show();
		});

		$(document).on("click", '.agenda_side_detail_main p', function(e) {
			var $minutesrow = $("#" + $(this).attr("target")).closest(".minute_row");
			var $agendarow = $minutesrow.prev();
			var $collapse = $agendarow.find('[data-toggle="collapse"]');
			if($collapse.hasClass("icon-down")) {
				$collapse.trigger("click");
			}
			var $that = $(this);

			setTimeout(function(){ 
				if($("#nav-tabContent-right").attr("classes") == "decision") {
					$("#" + $that.attr("target")).focus();
				} else if($("#nav-tabContent-right").attr("classes") == "important") {
					$("#" + $that.attr("target")).focus();
				} else if($("#nav-tabContent-right").attr("classes") == "task") {
					
					$("#" + $that.attr("target")).focus();
					$("#minutes-task-modal").modal();

				} else if($("#nav-tabContent-right").attr("classes") == "tag") {

					$that.attr("active-modal-icon", "");
					$("#" + $that.attr("target")).focus();
					$("#minutes-tag-modal").modal();
				}
			}, 100);
		});
	}
}
</script>